const translations = {
  "en": {
    "Cancel": "Cancel",
    "Confirm": "Confirm"
  },
  "zh-tw": {
    "Cancel": "取消",
    "Confirm": "確認"
  }
};

export default translations;
